"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetType = exports.UnitDimensionType = exports.UnitType = exports.DeliveryHubGroupBy = exports.GroupBy = exports.TimeGranularity = exports.TrendDirection = void 0;
var TrendDirection;
(function (TrendDirection) {
    TrendDirection[TrendDirection["Asc"] = 0] = "Asc";
    TrendDirection[TrendDirection["Desc"] = 1] = "Desc";
})(TrendDirection || (exports.TrendDirection = TrendDirection = {}));
var TimeGranularity;
(function (TimeGranularity) {
    TimeGranularity[TimeGranularity["None"] = 0] = "None";
    TimeGranularity[TimeGranularity["WoW"] = 1] = "WoW";
    TimeGranularity[TimeGranularity["MoM"] = 2] = "MoM";
    TimeGranularity[TimeGranularity["YoY"] = 3] = "YoY";
})(TimeGranularity || (exports.TimeGranularity = TimeGranularity = {}));
var GroupBy;
(function (GroupBy) {
    GroupBy[GroupBy["Merchant"] = 0] = "Merchant";
    GroupBy[GroupBy["Team"] = 1] = "Team";
    GroupBy[GroupBy["ParentTeam"] = 2] = "ParentTeam";
    GroupBy[GroupBy["Driver"] = 3] = "Driver";
    GroupBy[GroupBy["Fleet"] = 4] = "Fleet";
    GroupBy[GroupBy["All"] = 5] = "All";
    GroupBy[GroupBy["TaskType"] = 6] = "TaskType";
    GroupBy[GroupBy["DayOfWeek"] = 7] = "DayOfWeek";
    GroupBy[GroupBy["HourOfDay"] = 8] = "HourOfDay";
    GroupBy[GroupBy["Tags"] = 9] = "Tags";
    GroupBy[GroupBy["ServicePlans"] = 10] = "ServicePlans";
})(GroupBy || (exports.GroupBy = GroupBy = {}));
var DeliveryHubGroupBy;
(function (DeliveryHubGroupBy) {
    DeliveryHubGroupBy[DeliveryHubGroupBy["DayOfWeek"] = 101] = "DayOfWeek";
    DeliveryHubGroupBy[DeliveryHubGroupBy["HourOfDay"] = 102] = "HourOfDay";
    DeliveryHubGroupBy[DeliveryHubGroupBy["LocationRecipient"] = 103] = "LocationRecipient";
    DeliveryHubGroupBy[DeliveryHubGroupBy["LocationSender"] = 104] = "LocationSender";
    DeliveryHubGroupBy[DeliveryHubGroupBy["CountryRecipient"] = 105] = "CountryRecipient";
    DeliveryHubGroupBy[DeliveryHubGroupBy["CountrySender"] = 106] = "CountrySender";
    DeliveryHubGroupBy[DeliveryHubGroupBy["Carrier"] = 107] = "Carrier";
    DeliveryHubGroupBy[DeliveryHubGroupBy["FulfillmentType"] = 108] = "FulfillmentType";
    DeliveryHubGroupBy[DeliveryHubGroupBy["Service"] = 109] = "Service";
})(DeliveryHubGroupBy || (exports.DeliveryHubGroupBy = DeliveryHubGroupBy = {}));
var UnitType;
(function (UnitType) {
    UnitType[UnitType["Percent"] = 0] = "Percent";
    UnitType[UnitType["Distance"] = 1] = "Distance";
    UnitType[UnitType["Money"] = 2] = "Money";
    UnitType[UnitType["Number"] = 3] = "Number";
    UnitType[UnitType["Time"] = 4] = "Time";
})(UnitType || (exports.UnitType = UnitType = {}));
var UnitDimensionType;
(function (UnitDimensionType) {
    UnitDimensionType[UnitDimensionType["Weekday"] = 0] = "Weekday";
    UnitDimensionType[UnitDimensionType["Hour"] = 1] = "Hour";
    UnitDimensionType[UnitDimensionType["ETA"] = 2] = "ETA";
})(UnitDimensionType || (exports.UnitDimensionType = UnitDimensionType = {}));
var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["Number"] = 0] = "Number";
    WidgetType[WidgetType["LineChart"] = 1] = "LineChart";
    WidgetType[WidgetType["BarChart"] = 2] = "BarChart";
    WidgetType[WidgetType["PieChart"] = 3] = "PieChart";
    WidgetType[WidgetType["DonutChart"] = 4] = "DonutChart";
    WidgetType[WidgetType["ReversedBarChart"] = 5] = "ReversedBarChart";
    WidgetType[WidgetType["ReversedFullWidthBarChart"] = 6] = "ReversedFullWidthBarChart";
    WidgetType[WidgetType["BasicLineChart"] = 7] = "BasicLineChart";
    WidgetType[WidgetType["MultiHorizontalReversedBarChart"] = 8] = "MultiHorizontalReversedBarChart";
    WidgetType[WidgetType["DoubleYAxisChart"] = 9] = "DoubleYAxisChart";
})(WidgetType || (exports.WidgetType = WidgetType = {}));
//# sourceMappingURL=widgets.js.map